import { auth } from "../firebase/firebaseConfig";

let inFlight = null;
let inFlightUser = null;
let inFlightRefresh = false;

export function getSharedIdToken({ refresh = false } = {}) {
  const user = auth.currentUser;
  if (!user) return Promise.reject(new Error("Sign in is required."));
  if (inFlight && inFlightUser === user && inFlightRefresh === refresh) return inFlight;

  inFlightUser = user;
  inFlightRefresh = refresh;
  const request = Promise.resolve(user.getIdToken(refresh));
  const shared = request.finally(() => {
    if (inFlight === shared) {
      inFlight = null;
      inFlightUser = null;
      inFlightRefresh = false;
    }
  });
  inFlight = shared;
  return shared;
}

export function resetSharedIdTokenForTests() {
  inFlight = null;
  inFlightUser = null;
  inFlightRefresh = false;
}
